
// Value changes as page scrolls
export const getViewportBoundingBox = (element: HTMLElement) => {
  const { bottom, left, right, top } = element.getBoundingClientRect();
  return { bottom, left, right, top };
};

export const doesElementFullyContainChild = (parent: HTMLElement, child: HTMLElement) => {
  const parentBox = getViewportBoundingBox(parent);
  const childBox = getViewportBoundingBox(child);
  return (
    parentBox.bottom >= childBox.bottom &&
    parentBox.left <= childBox.left &&
    parentBox.right >= childBox.right &&
    parentBox.top <= childBox.top
  );
};

export const isInViewport = (elem: HTMLElement) => {
  if (!elem) {
    return false;
  }
  const distance = elem.getBoundingClientRect();
  return (
    distance.top >= 0 && distance.left >= 0 &&
    distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

interface IRectPositionCheckingBoundsParam {
  elem?: HTMLElement | null;
  margin?: number;
  position?: { x: number; y: number };
}

export const getRectPositionCheckingBounds = ({ elem, margin, position }: IRectPositionCheckingBoundsParam) => {
  const safePos = position || { x: 0, y: 0 };
  const safeMargin = margin || 0;

  if (!elem) {
    return safePos;
  }

  const { height, width } = elem.getBoundingClientRect();
  const { innerHeight, innerWidth } = window;

  const { x, y } = safePos;
  const passedX = x + width + safeMargin > innerWidth;
  const passedY = y + height + safeMargin > innerHeight;
  const newX = passedX ? (innerWidth - width - safeMargin) : x;
  const newY = passedY ? (innerHeight - height - safeMargin) : y;

  return { x: newX, y: newY };
};

export const matchMedia = window.matchMedia || (() => {
  // For browsers that support matchMedium api such as IE 9 and webkit
  // @ts-ignore
  let styleMedia = (window.styleMedia || window.media);

  // For those that don't support matchMedium
  if (!styleMedia) {
    const style = document.createElement('style');
    const script = document.getElementsByTagName('script')[0];
    let info: CSSStyleDeclaration;

    style.type = 'text/css';
    style.id = 'matchmediajs-test';

    if (!script) {
      document.head.appendChild(style);
    } else {
      // @ts-ignore
      script.parentNode.insertBefore(style, script);
    }

    // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
    // @ts-ignore
    info = ('getComputedStyle' in window) ? window.getComputedStyle(style, null) : style.currentStyle;

    // @ts-ignore
    styleMedia = {
      matchMedium(media) {
        const text = `@media ${media}{ #matchmediajs-test { width: 1px; } }`;

        // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
        // @ts-ignore
        if (style.styleSheet) {
          // @ts-ignore
          style.styleSheet.cssText = text;
        } else {
          style.textContent = text;
        }

        // Test if media query is true or false
        return info.width === '1px';
      },
    };
  }

  return (media: string) => {
    return {
      matches: styleMedia.matchMedium(media || 'all'),
      media: media || 'all',
    };
  };
})();

export const FULLSCREEN_VIDEO_ID = 'fullscreen-video-id';

export const hasAirplaySupport = !!window.WebKitPlaybackTargetAvailabilityEvent;
